import Permisos from '@/router/permisos'
import {Dashboard} from '@/handler/session'

 

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewDashboard = () => import('./Index')
const ViewDashboardCamion = () => import('./IndexCamion')

let _component = Dashboard.getDashboard()

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: _component == "default" ? ViewDashboard : _component == "camion" ? ViewDashboardCamion : ViewDashboard,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
